import normalize from "json-api-normalize";
import Attributes from "../../../models/Attributes";

export default {
  methods: {
    updateCollectionAssets(collection, successCallback) {
      if (!collection) return;

      this.$http.patch(`/curators/collection_assets/${collection.id}`, {
        collection: {
          added_asset_ids: this.selectedAssetIds
        }
      }).then(fulfilled => {
        const count = fulfilled.body.updated || 0;
        const collection = normalize(fulfilled.body.collection).get(Attributes.collectionAttributes);
        window.collectionsStore.updateCollection(collection);

        const h = this.$createElement;
        const toastMessage = h('div', [
          `${count} ${count === 1 ? 'asset was' : 'assets were'} added to `,
          h(
            'a',
            {attrs: {href: `/curators/collections/${collection.id}`}},
            [collection.name]
          )
        ])

        this.showToast(toastMessage, "Result");
        if (successCallback) {
          successCallback()
        }
      }, rejected => {
        this.showErrorToast("There was an error while adding these assets");
      })
    }
  }
}